  import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/home.vue";

import Emergency from "../components/emergency/emergency.vue";
import ordinaryUser from "../components/ordinary/index.vue";
import factoryUser from "../components/factory/index.vue";
import electricianUser from "../components/electrician/index.vue";
//

// 这是资源厂商的二级页面
import factoryEqu from "../view/factory/equipment.vue";
import factoryEme from "../view/factory/emergency.vue";
import orderEqu from "../view/factory/order-equ.vue";
import orderEme from "../view/factory/order-eme.vue";
import statistics from "../view/factory/statistics.vue";
import factoryAccount from "../view/factory/account.vue";
import factoryEvaluate from "../view/factory/evaluate.vue";
import factoryMineData from "../view/factory/mine-data.vue";
import factoryMinePassword from "../view/factory/mine-password.vue";
import factoryTips from "../view/factory/tips.vue";
import factoryDetailEqu from "../view/factory/detail-equ.vue";
import factoryDetailEme from "../view/factory/detail-eme.vue";
import factoryEquAdd from "../view/factory/add-equ.vue";
import factoryEmeAdd from "../view/factory/add-eme.vue";

// 这是电工的二级页面
import eleOrder from "../view/electrician/order.vue";
import eleEvaluate from "../view/electrician/evaluate.vue";
import eleBill from "../view/electrician/bill.vue";
import eleMineData from "../view/electrician/mine-data.vue";
import eleMinePassword from "../view/electrician/mine-password.vue";
import eleTips from "../view/electrician/tips.vue";
import eleDetail from "../view/electrician/detail.vue";

// 个人中心
import personRouters from "./personal";
// 订单详情
import orderRouters from "./orderDetail";
Vue.use(VueRouter);
const routes = [
  ...personRouters,
  ...orderRouters,
  // {
  //   path: "/",
  //   name: "index",
  //   component: ordinaryUser,
  //   // component: ordinaryUser,
  //   meta: {
  //     title: "首页",
  //   },
  // },

  {
    path: "/",
      name: "ordinaryUser",
      redirect: "/ordinaryUser/index",
      component: ordinaryUser,
      children: [
    {
      path: "index",
      component: () => import("../view/ordinary/index.vue"),
      meta: {
        title: "首页",
        requiresAuth: false
      },
    }]
  },

  {
    path: "/404",
    name: "404",
    component: () => import("../view/user/404.vue"),
    meta: {
      title: "404",
    },
  },

  {
    path: "/download",
    name: "download",
    component: () => import("../view/user/download.vue"),
    meta: {
      title: "APP下载",
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../view/user/register.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: "/registerDetails",
    name: "registerDetails",
    component: () => import("../view/user/registerDetails.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () => import("../view/user/agreement.vue"),
    meta: {
      title: "平台服务协议及隐私条款",
    },
  },
  {
    path: "/service",
    name: "service",
    component: () => import("../view/customerService/index.vue"),
    meta: {
      title: "无忧客服",
    },
  },
  {
    path: "/ordinaryUser",
    name: "ordinaryUser",
    redirect: "/ordinaryUser/index",
    component: ordinaryUser,
    children: [
      {
        path: "index",
        component: () => import("../view/ordinary/index.vue"),
        meta: {
          title: "首页",
          requiresAuth: false
        },
      },
      {
        path: "deviceList",
        component: () => import("../view/ordinary/deviceList.vue"),
        meta: {
          title: "收藏夹",
        },
      },
      {
        path: "shopList",
        component: () => import("../view/ordinary/shopList.vue"),
        meta: {
          title: "列表详情",
        },
      },
      {
        path: "rent",
        component: () => import("../view/ordinary/rent.vue"),
        meta: {
          title: "保电类",
        },
      },
      {
        path: "rentDetail",
        component: () => import("../view/ordinary/rentDetail.vue"),
        meta: {
          title: "设备详情",
        },
      },
      {
        path: "rentApply",
        component: () => import("../view/ordinary/rentApply.vue"),
        meta: {
          title: "设备租赁申请",
        },
      },
      {
        path: "emergency",
        component: () => import("../view/ordinary/emergency.vue"),
        meta: {
          title: "照明类",
        },
      },
      {
        path: "emergencyDetail",
        component: () => import("../view/ordinary/emergencyDetail.vue"),
        meta: {
          title: "应急保电详细",
        },
      },
      {
        path: "emergencyApply",
        component: () => import("../view/ordinary/emergencyApply.vue"),
        meta: {
          title: "应急保电申请",
        },
      },
      {
        path: "share",
        component: () => import("../view/ordinary/share.vue"),
        meta: {
          title: "其他类",
        },
      },
      {
        path: "shareDetail",
        component: () => import("../view/ordinary/shareDetail.vue"),
        meta: {
          title: "共享电工详情",
        },
      },
      {
        path: "shareApply",
        component: () => import("../view/ordinary/shareApply.vue"),
        meta: {
          title: "共享电工申请",
        },
      },
      {
        path: "createShare",
        component: () => import("../view/ordinary/createShare.vue"),
        meta: {
          title: "发布电工申请",
        },
      },
      {
        path: "news",
        component: () => import("../view/ordinary/news.vue"),
        meta: {
          title: "新闻资讯",
        },
      },
      {
        path: "newsdetail",
        component: () => import("../view/ordinary/newsdetail.vue"),
        meta: {
          title: "新闻资讯",
        },
      },
      {
        path: "event",
        component: () => import("../view/ordinary/event.vue"),
        meta: {
          title: "活动公告",
        },
      },
      {
        path: "eventinfo",
        component: () => import("../view/ordinary/eventInfo.vue"),
        meta: {
          title: "活动公告",
        },
      },
      {
        path: "blackout",
        component: () => import("../view/ordinary/blackout.vue"),
        meta: {
          title: "停电信息",
        },
      },
      {
        path: "blackoutdetail",
        component: () => import("../view/ordinary/blackoutdetail.vue"),
        meta: {
          title: "停电信息",
        },
      },
      {
        path: "contact",
        component: () => import("../view/ordinary/contact.vue"),
        meta: {
          title: "联系客服",
        },
      },
      {
        path: "companyEme",
        component: () => import("../view/ordinary/companyEme.vue"),
        meta: {
          title: "公司设备",
        },
      },
      {
        path: "createCarOrder",
        component: () => import("../view/car/createOrder.vue"),
        meta: {
          title: "合并下单",
        },
      },
      {
        path: "introduction",
        component: () => import("../view/platform/introduction.vue"),
        meta: {
          title: "平台简介",
        },
      }, {
        path: "serviceCase",
        component: () => import("../view/platform/serviceCase.vue"),
        meta: {
          title: "服务案例",
        },
      },{
        path: "serviceResources",
        component: () => import("../view/platform/serviceResources.vue"),
        meta: {
          title: "服务资源",
        },
      },
    ],
  },
  {
    path: "/factoryUser",
    name: "factoryUser",
    component: factoryUser,
    redirect: "/factoryUser/index",
    children: [
      {
        path: "/factoryUser/index",
        name: "factoryUser/index",
        component: () => import("../view/factory/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "/factoryUser/factoryEqu",
        name: "factoryUser/factoryEqu",
        component: factoryEqu,
        meta: {
          title: "成套设备",
        },
      },
      {
        path: "/factoryUser/factoryEme",
        name: "factoryUser/factoryEme",
        component: factoryEme,
        meta: {
          title: "应急保电设备",
        },
      },
      {
        path: "/factoryUser/orderEqu",
        name: "factoryUser/orderEqu",
        component: orderEqu,
        meta: {
          title: "成套设备订单",
        },
      },
      {
        path: "/factoryUser/orderEme",
        name: "factoryUser/orderEme",
        component: orderEme,
        meta: {
          title: "应急保电订单",
        },
      },
      {
        path: "/factoryUser/statistics",
        name: "factoryUser/statistics",
        component: statistics,
        meta: {
          title: "统计分析",
        },
      },
      {
        path: "/factoryUser/factoryAccount",
        name: "factoryUser/factoryAccount",
        component: factoryAccount,
        meta: {
          title: "资金账号管理",
        },
      },
      {
        path: "/factoryUser/factoryEvaluate",
        name: "factoryUser/factoryEvaluate",
        component: factoryEvaluate,
        meta: {
          title: "我的评价",
        },
      },
      {
        path: "/factoryUser/factoryEvaluateDetail",
        name: "factoryUser/factoryEvaluateDetail",
        component: () => import("../view/factory/evaluate-detail.vue"),
        meta: {
          title: "评价详情",
        },
      },
      {
        path: "/factoryUser/factoryMineData",
        name: "factoryUser/factoryMineData",
        component: factoryMineData,
        meta: {
          title: "个人中心-个人资料",
        },
      },
      {
        path: "/factoryUser/factoryMinePassword",
        name: "factoryUser/factoryMinePassword",
        component: factoryMinePassword,
        meta: {
          title: "个人中心-密码管理",
        },
      },
      {
        path: "/factoryUser/factoryTips",
        name: "factoryUser/factoryTips",
        component: factoryTips,
        meta: {
          title: "留言管理",
        },
      },
      {
        path: "/factoryUser/factoryDetailEqu",
        name: "factoryUser/factoryDetailEqu",
        component: factoryDetailEqu,
        meta: {
          title: "订单详情",
        },
      },
      {
        path: "/factoryUser/factoryDetailEme",
        name: "factoryUser/factoryDetailEme",
        component: factoryDetailEme,
        meta: {
          title: "订单详情",
        },
      },
      {
        path: "/factoryUser/factoryEquAdd",
        name: "factoryUser/factoryEquAdd",
        component: factoryEquAdd,
        meta: {
          title: "成套设备租赁-编辑",
        },
      },
      {
        path: "/factoryUser/factoryEmeAdd",
        name: "factoryUser/factoryEmeAdd",
        component: factoryEmeAdd,
        meta: {
          title: "应急保电-编辑",
        },
      },
      {
        path: "/factoryUser/customerServer",
        name: "factoryUser/customerServer",
        component: () => import("../view/customerService/factory.vue"),
        meta: {
          title: "联系客服",
        },
      },
      {
        path: "/factoryUser/changeEqu",
        name: "/factoryUser/changeEqu",
        component: () => import("../view/factory/change-equ.vue"),
        meta: {
          title: "修改成套设备列表",
        },
      },
      {
        path: "/factoryUser/changeEme",
        name: "/factoryUser/changeEme",
        component: () => import("../view/factory/change-eme.vue"),
        meta: {
          title: "修改保电设备列表",
        },
      },
    ],
  },
  {
    path: "/electricianUser",
    name: "electricianUser",
    component: electricianUser,
    redirect: "/electricianUser/index",
    children: [
      {
        path: "/electricianUser/index",
        name: "electricianUser/index",
        component: () => import("../view/electrician/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "/electricianUser/eleOrder",
        name: "electricianUser/eleOrder",
        component: eleOrder,
        meta: {
          title: "我的订单",
        },
      },
      {
        path: "/electricianUser/eleEvaluate",
        name: "electricianUser/eleEvaluate",
        component: eleEvaluate,
        meta: {
          title: "我的评价",
        },
      },
      {
        path: "/electricianUser/eleEvaluateDetail",
        name: "electricianUser/eleEvaluateDetail",
        component: () => import("../view/electrician/evaluate-detail.vue"),
        meta: {
          title: "评价详情",
        },
      },
      {
        path: "/electricianUser/eleBill",
        name: "electricianUser/eleBill",
        component: eleBill,
        meta: {
          title: "我的收入",
        },
      },
      {
        path: "/electricianUser/eleMineData",
        name: "electricianUser/eleMineData",
        component: eleMineData,
        meta: {
          title: "个人中心-个人资料",
        },
      },
      {
        path: "/electricianUser/eleMinePassword",
        name: "electricianUser/eleMinePassword",
        component: eleMinePassword,
        meta: {
          title: "个人中心-密码管理",
        },
      },
      {
        path: "/electricianUser/eleTips",
        name: "electricianUser/eleTips",
        component: eleTips,
        meta: {
          title: "个人中心-留言列表",
        },
      },
      {
        path: "/electricianUser/eleDetail",
        name: "electricianUser/eleDetail",
        component: eleDetail,
        meta: {
          title: "订单详情",
        },
      },
      {
        path: "/electricianUser/customerServer",
        name: "electricianUser/customerServer",
        component: () => import("../view/customerService/elec.vue"),
        meta: {
          title: "联系客服",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
